import React from 'react';
import { Table } from 'antd';
import cn from 'classnames';
import classes from './QMASTable.module.scss';

const QMASTable = (props) => {
  const { className, bordered = true } = props;
  return (
    <Table
      {...props}
      className={cn(
        classes.table,
        {
          [classes.noneBorder]: !bordered,
        },
        className
      )}
    />
  );
};

export default QMASTable;
